import type { Grade } from '@backmarket/http-api'

import { MODAL_NAMES } from '../../constants'

import type { DesktopIllustration, Step } from './utils/types'

export const STEP_ILLUSTRATION_SMARTPHONE: Record<string, DesktopIllustration> =
  {
    battery: {
      src: '/img/product/funnel/smartphone/step-battery.jpg',
      position: 'center_top',
    },
    dual_sim: {
      src: '/img/product/funnel/smartphone/step-sim.jpg',
      position: 'center_center',
    },
    storage: {
      src: '/img/product/funnel/smartphone/step-storage.jpg',
      position: 'center_top',
    },
  }

export const STEP_ILLUSTRATION_MACBOOK: Record<string, DesktopIllustration> = {
  battery: {
    src: '/img/product/funnel/macbook/step-battery.jpg',
    position: 'center_top',
  },
  processor_type_and_speed: {
    src: '/img/product/funnel/step-processor.jpg',
    position: 'center_bottom',
  },
  processor_type_and_graphic_card: {
    src: '/img/product/funnel/step-processor.jpg',
    position: 'center_bottom',
  },
  memory: {
    src: '/img/product/funnel/step-memory.jpg',
    position: 'center_top',
  },
  storage: {
    src: '/img/product/funnel/macbook/step-storage.jpg',
    position: 'center_top',
  },
  display: {
    src: '/img/product/funnel/step-display.jpg',
    position: 'center_top',
  },
}

export const STEP_ILLUSTRATION_AIRPODS: Record<string, DesktopIllustration> = {
  magsafe_compatible: {
    src: '/img/product/funnel/airpods/step-magsafe.jpg',
    position: 'center_bottom',
  },
}

export const STEP_ILLUSTRATION_IPAD: Record<string, DesktopIllustration> = {
  screen_size: {
    src: '/img/product/funnel/ipads/step-screen-size.png',
    position: 'center_top',
  },
}

export const STEP_ILLUSTRATION_LAPTOP: Record<string, DesktopIllustration> = {
  processor: {
    src: '/img/product/funnel/step-processor.jpg',
    position: 'center_bottom',
  },
  memory: {
    src: '/img/product/funnel/step-memory.jpg',
    position: 'center_top',
  },
}

export const STEP_ILLUSTRATION_GENERIC: Record<string, DesktopIllustration> = {
  storage: {
    src: '/img/product/funnel/step-storage.jpg',
    position: 'center_top',
  },
  network: {
    src: '/img/product/funnel/step-network.jpg',
    position: 'center_top',
  },
  display: {
    src: '/img/product/funnel/step-display.jpg',
    position: 'center_top',
  },
}

export const STEP_ILLUSTRATION_SERVICES: Record<string, DesktopIllustration> = {
  trade_in: { src: '/img/buyback/step-trade-in-4.jpg', position: 'center_top' },
}

export const STEP_GUIDANCE: Record<
  string,
  NonNullable<Step['guidance']>['modalName']
> = {
  grades: MODAL_NAMES.CONDITION_COMPARISON,
  battery: MODAL_NAMES.NEW_BATTERY,
  dual_sim: MODAL_NAMES.SIM,
  processor_type_and_speed: MODAL_NAMES.MACBOOK_PROCESSOR,
  processor_type_and_graphic_card: MODAL_NAMES.MACBOOK_PROCESSOR,
  trade_in: MODAL_NAMES.TRADE_IN,
}

export const STEP_COLUMNS: Record<string, number> = {
  color: 2,
  band_color: 2,
}

export const STEPS_WITHOUT_ICONS = [
  'display',
  'magsafe_compatible',
  'case_size',
  'case_material',
  'band_type',
]

export const GRADES_STEPS = ['grades']

export const StepIndexes = {
  SCREEN: 0,
  SHELL: 1,
  BATTERY: 2,
  PREMIUM: 3,
}

export type StepStatus = 'unknown' | 'accepted' | 'declined'

// ToDo: remove after https://github.com/BackMarket/front-apps/pull/9558
export type OfferGradeWithoutPremium = Extract<Grade['value'], 10 | 11 | 12>

export const ONE_PX_EMPTY_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII='
